<template>
  <div class="service-agreement">
    <pageHeader title="服务协议" />
    <div class="container">
        <iframe width="100%" height="100%" :src="url" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
export default {
    components: {
        pageHeader
    },
    data() {
        return {
            url: 'https://wmsy666.com/serviceAgreement'
        }
    }
}
</script>

<style lang="scss" scoped>
.service-agreement {
    height: 100vh;
    .container {
        height: 100%;
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/serviceAgreement/index.vue